export default __webpack_public_path__ + "static/turkish_avatar_flag-84c19a6e30d5503427b9bd234312e840.png";